import * as React from "react"
import Grid from "@mui/material/Grid"
import SpeedIcon from '@mui/icons-material/Speed';

import { Box, Checkbox, FormControlLabel, InputAdornment, TextField } from "@mui/material"
import RentalNoteAccordion from "./RentalNoteAccordion"
import { moneyFormat } from "../../Utils";

export default function ContractItemData({ item, itemData, rentalItem, updateOdometerReading, updateQuestion, updateFeeOptional, updateFeeRefunded, data_key, refresh_function }) {
    const disabled = data_key === 'checkout_data' ? !['RESERVED'].includes(item.status) : !['CHECKED_OUT', 'CHECKING_IN'].includes(item.status)
    const optional_fees = Object.fromEntries(Object.entries(itemData.fees_data).filter(([k, v]) => v.optional))
    const has_optional_fees = Object.keys(optional_fees).length > 0
    const refundable_fees = Object.fromEntries(Object.entries(itemData.fees_data).filter(([k, v]) => v.refundable))
    const has_refundable_fees = Object.keys(refundable_fees).length > 0

    return (
        (<Box key={item.id} sx={{ border: 1, m: 1, p: 1 }}>
            <h3 style={{marginBottom: '8px', marginTop: '8px'}}>{rentalItem?.unique_name}</h3>
            <Grid container justifyContent="space-between">
                <Grid xs={2}>
                    {rentalItem?.image_path !== undefined && rentalItem?.image_path !== null && rentalItem?.image_path !== "" &&
                        <Box component="img" alt={"Rental Item"} src={`/customerimages/client/${item.client_id}/rentalitems/${rentalItem.id}/${rentalItem.image_path}`} sx={{ maxHeight: '160px', maxWidth: '100%' }} />
                    }
                    {(rentalItem?.image_path === undefined || rentalItem?.image_path === null || rentalItem?.image_path === "") &&
                        <Box component="img" alt={"Rental Item"} src={`/noimage.png`} sx={{ maxHeight: '160px', maxWidth: '100%' }} />
                    }
                </Grid>
                <Grid xs={3}>
                    <Grid container direction={"column"}>
                        <Grid xs>
                            {itemData[data_key]?.odometer_reading !== undefined &&
                                <TextField
                                    margin="dense"
                                    id={`odometer_reading_${item.id}`}
                                    label="Odometer Reading"
                                    type="number"
                                    fullWidth
                                    variant="filled"
                                    value={itemData[data_key]?.odometer_reading || 0}
                                    onChange={(event) => updateOdometerReading(item.id, event.target.value, data_key)}
                                    disabled={disabled}
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SpeedIcon />
                                                </InputAdornment>
                                            )
                                        }
                                    }}
                                />
                            }
                        </Grid>
                        {data_key === "checkout_data" && has_optional_fees &&
                            <Box>
                                <Grid xs>
                                    <span><b>Optional Fees</b></span>
                                </Grid>
                                {Object.keys(optional_fees).map((key, index) =>
                                    <Grid xs>
                                        <Grid container alignItems={"center"}>
                                            <Grid xs sx={{ textAlign: 'right', pr: 1 }}>
                                                <span >{item.rental_contract_item_charges.find((charge) => (charge.fee_id ?? '').toString() === key).description} ${moneyFormat(item.rental_contract_item_charges.find((charge) => (charge.fee_id ?? '').toString() === key).estimated_cost)}</span>
                                            </Grid>
                                            <Grid xs="auto">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={optional_fees[key].optional_selection === true}
                                                            onChange={(event) => updateFeeOptional(item.id, key, event.target.checked)}
                                                            disabled={disabled}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Box>
                        }
                        {data_key === "checkin_data" && has_refundable_fees &&
                            <Box>
                                <Grid xs>
                                    <span><b>Refundable Fees</b></span>
                                </Grid>
                                {Object.keys(refundable_fees).map((key, index) =>
                                    <Grid xs>
                                        <Grid container alignItems={"center"}>
                                            <Grid xs sx={{ textAlign: 'right', pr: 1 }}>
                                                {item.status === "CHECKED_OUT" ?
                                                    <span >{item.rental_contract_item_charges.find((charge) => (charge.fee_id ?? '').toString() === key).description} ${moneyFormat(item.rental_contract_item_charges.find((charge) => (charge.fee_id ?? '').toString() === key).estimated_cost)}</span>
                                                    :
                                                    <span >{item.rental_contract_item_charges.find((charge) => (charge.fee_id ?? '').toString() === key).description} ${moneyFormat(item.rental_contract_item_charges.find((charge) => (charge.fee_id ?? '').toString() === key).actual_cost)}</span>
                                                }
                                            </Grid>
                                            <Grid xs="auto">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={refundable_fees[key].refunded === true}
                                                            onChange={(event) => updateFeeRefunded(item.id, key, event.target.checked)}
                                                            disabled={disabled}
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Box>
                        }

                    </Grid>
                </Grid>
                <Grid xs>
                    <Grid container direction={"column"}>
                        {(itemData[data_key].questions ?? []).map((question, index) =>
                            <Grid xs>
                                <Grid container alignItems={"center"}>
                                    <Grid xs sx={{ textAlign: 'right', pr: 1 }}>
                                        <span >{question.text}</span>
                                    </Grid>
                                    <Grid xs="auto">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={question.answer === true}
                                                    onChange={() => updateQuestion(item.id, index, true, data_key)}
                                                    disabled={disabled}
                                                />
                                            }
                                            label="Yes"
                                        />
                                    </Grid>
                                    <Grid xs="auto">
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={question.answer === false}
                                                    onChange={() => updateQuestion(item.id, index, false, data_key)}
                                                    disabled={disabled}
                                                />
                                            }
                                            label="No"
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
            <RentalNoteAccordion
                refresh_function={refresh_function}
                rental_item_id={item.rental_item_id}
                rental_contract_item_id={item.id}
            />
        </Box>)
    );
}